module.exports = __webpack_public_path__ + "img/lead-9e.60c7afa2.png";